"use strict";

exports.__esModule = true;
exports.default = void 0;

var _ActionTypes = _interopRequireDefault(require("./ActionTypes"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = {
  init: function init() {
    return {
      type: _ActionTypes.default.INIT
    };
  },
  push: function push(location) {
    return {
      type: _ActionTypes.default.PUSH,
      payload: location
    };
  },
  replace: function replace(location) {
    return {
      type: _ActionTypes.default.REPLACE,
      payload: location
    };
  },
  go: function go(delta) {
    return {
      type: _ActionTypes.default.GO,
      payload: delta
    };
  },
  dispose: function dispose() {
    return {
      type: _ActionTypes.default.DISPOSE
    };
  }
};
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/found/node_modules/farce/lib/Actions.js
// module id = 274
// module chunks = 0